export default "__VITE_ASSET__BLflVrsF__"